import {authService} from "../services";
import {message} from "../shared/message";
import axios from "axios";

const user = JSON.parse(localStorage.getItem("user") === 'undefined' ? null : localStorage.getItem("user"));
const initialState = user ? {user, loggedIn: true, accessLevel: 0} : {user: null, loggedIn: false, accessLevel: 0};


export const auth = {
        namespaced: true,
        state: initialState,
        actions: {
            login({commit, state}, {'cred': {username, password, access_token, type, product}, vm}) {
                authService.login({username, password, access_token, type, product}).then(user => {
                    console.log(user);
                    if (user) {
                        commit("loginSuccess", user);
                        let homepage = "/AdminPage";
                        if (user.role == 43){
                            homepage = "/SchoolHomeInfo";
                        }

/*
                        if (user.role == 1 || user.role == 4) {
                            homepage = "/TeacherPage";
                        } else if (user.role == 2) {
                            homepage = "/StudentPage";
                        } else {
                            homepage = "/AdminPage";
                        }
*/
                        if (localStorage.redirect != undefined && localStorage.redirect != null) {
                            //message.success(vm.$t('lang.auth.logged_in') + user.fullName);
                            let to = JSON.parse(localStorage.redirect);
                            localStorage.removeItem("redirect");
                            message.success(vm.$t('lang.auth.logged_in') + user.fullName, to.path);
                        } else {
                            message.success(vm.$t('lang.auth.logged_in') + user.fullName, homepage);
                        }
                    } else {
                        message.error(vm.$t('lang.auth.invalid'));
                        vm.updateCount();
                    }
                });
            },

            updateRole({commit, state}, {role,vm}) {
                let user = state.user;
                user.role = role;
                axios
                    .post(`${process.env.VUE_APP_API_URL}/changeRole?role=`+role)
                    .then(data => {
                            if (data.success) {
                                localStorage.setItem("user", JSON.stringify(user));
                                commit("loginSuccess", user);
                                vm.$router.push('/HomePage?time='+(new Date().getTime()));
                            }
                        },
                        error => {
                            console.log(error);
                        }
                    );
            },

            token({commit, state}, {token, vm}) {
                localStorage.setItem("token", JSON.stringify({access_token: token}));
                axios.defaults.headers.common["Authorization"] = "Bearer " + token;
                axios
                    .get(`${process.env.VUE_APP_API_URL}/profile`, {})
                    .then(function (data) {
                        if (data) {
                            console.info(data);
                            localStorage.setItem("user", JSON.stringify(data));

                            if (data) {
                                commit("loginSuccess", data);
                                let homepage;
                                if (data.role === 1) {
                                    homepage = "/TeacherPage";
                                } else if (data.role === 2) {
                                    homepage = "/StudentPage";
                                } else {
                                    homepage = "/AdminPage";
                                }
                                message.success(vm.$t('lang.auth.logged_in') + data.fullName, homepage);
                            } else {
                                message.error(vm.$t('lang.auth.invalid'), "/");
                            }
                        }
                    });
            },

            logout({commit, state}, {vm}) {
                authService.logout();
                commit("logout");
                //const redirectUri = window.location.protocol + '//' + window.location.host;
                //window.location = process.env.VUE_APP_LOGOUT_URL + '?redirect_uri=' + encodeURI(redirectUri);
                message.success(vm.$t('lang.auth.logged_out'), "/login");
            }
        },
        mutations: {
            loginSuccess(state, user) {
                state.loggedIn = true;
                state.user = user;
            }
            ,
            setAccessLevel(state, accessLevel) {
                state.accessLevel = accessLevel;
            }
            ,
            logout(state) {
                state.loggedIn = false;
                state.user = null;
            }
        }
    }
;
